import dynamic from 'next/dynamic';

const MainContainer = dynamic(() => import('./MainContainer'));
export { MainContainer };
